import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const rotasLiberadasInadimplente = ['/planos', '/financeiro', '/configuracoes', '/admin'];

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');

  if (!token || !user) {
    return <Navigate to="/login" replace />;
  }

  // Verificar se conta está suspensa por inadimplência
  try {
    const userData = JSON.parse(user);
    const isSuspensa = userData?.conta_suspensa === true;
    if (isSuspensa) {
      const isRotaLiberada = rotasLiberadasInadimplente.some(r => location.pathname.startsWith(r)) || location.pathname === '/';
      if (!isRotaLiberada) {
        return <Navigate to="/planos" replace />;
      }
    }
  } catch {}

  return children;
};

export default ProtectedRoute;
